$(function () {
  $('input[name="tabz"]')
    .on("change", function () {
      var selected = $(this).attr("id");
      $(".tab")
        .hide()
        .filter('[data-value="' + selected + '"]')
        .show();
    })
    .trigger("change");
});

// document.addEventListener("DOMContentLoaded", function() {
//     function truncateTitles() {
//         const productTitles = document.querySelectorAll(".product-card__title");

//         productTitles.forEach(title => {
//             const text = title.textContent;
//             if (text.length > 24) {
//                 title.textContent = text.slice(0, 24) + "...";
//             }
//         });
//     }
//     setInterval(truncateTitles, 5); 
// });

if ($(window).width() < 400) {
  function truncateBold() {
    document.querySelectorAll('.product-card .product-card__details strong').forEach((strongElement) => {
      const text = strongElement.textContent;
      const maxLength = 20;
      if (text.length > maxLength) {
        strongElement.textContent = text.substring(0, maxLength) + '...';
      }
    });
  }
  setInterval(truncateBold, 5);
}


var swiper = new Swiper(".is-review", {
  slidesPerView: 1,
  spaceBetween: 20,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    767: {
      slidesPerView: 2.25,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 24,
    },
    1440: {
      slidesPerView: 4,
      spaceBetween: 24,
    },
  },
});

document.addEventListener("DOMContentLoaded", function () {
  const swiper_second = new Swiper(".swiper.is-second", {
    slidesPerView: 4,
    spaceBetween: 24,
    pagination: {
      el: ".swiper-pagination-second",
      clickable: true,
    },
    breakpoints: {
      0: { slidesPerView: 1, spaceBetween: 10 },
      499: { slidesPerView: 1, spaceBetween: 10 },
      767: { slidesPerView: 2, spaceBetween: 16 },
      991: { slidesPerView: 3, spaceBetween: 16 },
      1440: { slidesPerView: 4, spaceBetween: 24 },
    },
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Select all product video wrappers on the page
  const videoWrappers = document.querySelectorAll(".product-video-wrapper");

  videoWrappers.forEach(function (wrapper) {
    // Get references within this wrapper
    const video = wrapper.querySelector(".product-video");
    const muteToggle = wrapper.querySelector(".mute-toggle");
    const muteIcon = wrapper.querySelector(".mute-icon");
    const unmuteIcon = wrapper.querySelector(".unmute-icon");

    // Guard clause if elements are missing for any reason
    if (!video || !muteToggle) return;

    // For better performance/SEO
    video.setAttribute("loading", "lazy");
    video.setAttribute("title", "Product video");

    // Function to sync icon states
    const updateIcons = () => {
      if (video.muted) {
        muteIcon.style.display = "block";
        unmuteIcon.style.display = "none";
      } else {
        muteIcon.style.display = "none";
        unmuteIcon.style.display = "block";
      }
    };

    // Toggle mute on button click
    muteToggle.addEventListener("click", function () {
      video.muted = !video.muted;
      updateIcons();
    });

    // Toggle mute on video click
    video.addEventListener("click", function () {
      video.muted = !video.muted;
      updateIcons();
    });

    // Initialize icons
    updateIcons();
  });
});
